import { Component, ElementRef, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { map } from 'rxjs/operators';
import { GlobalConstants } from 'src/app/common/constants/global.constant';
import { environment } from '../../../../environments/environment';
import { OemConstants } from '../../../../app/core/routing/services/oem/constants/oem.constants';
import { OemService } from '../../../../app/core/routing/services/oem/oem.service';
import { Utils } from '../../../common/utils/utils';
import { countryConstants } from '../../../core/routing/constants/country.constant';
import { CommonModule } from '@angular/common';
import moment from 'moment';

@Component({
  selector: 'iposcen-create-attractor-loop-oem',
  templateUrl: './create-attractor-loop-oem.component.html',
  styleUrls: ['./create-attractor-loop-oem.component.scss']
})
export class CreateAttractorLoopOemComponent implements OnInit {
  textLable = GlobalConstants.NAME;
  @Output('goToAttrDashBoard') readonly isCreateAttrEnable = new EventEmitter;
  @Input('getSelectedList') selectedSystemIdList;
  @ViewChild('search') searchInputField: ElementRef;
  @ViewChild('name') nameInputElement: ElementRef;  
  @ViewChild('systIDError') systIDError: ElementRef;
  systemIdList = new Map();
  displayData = [];
  displayCountryFirstLetter = [];
  page = 1;
  tableSize = 10;
  showFrom: number;
  showTo: number;
  searchData;
  searchDataList2;
  searchDataList1;
  selectedIds = new Map();
  onlyAvailableId = new Map();
  alreadySelected = new Map();
  selectLable: string;
  selectAllDisable = false;
  mainAfterPopupDisplay = [];
  allcountries = [] as any;
  countries = [] as any;
  excludedCountries = [] as any;
  selectedLocations = [] as any;
  dragdisabled = false;
  showLocationUnknown = true;
  getSystemIdsObserver = {}
  isAllValidDataSelected = false;  
  editPayload ={};
  LastPayloadFlag:boolean =false;
  checkFlag:boolean = false;
  isAddMoreDisabled = true;
  isFileError = false;
  isFieldRequired=false;
  //new added
  comments = '';
  divideDateFormat: boolean = true;
  // constants ref
  oemConst = OemConstants;
  globalConst = GlobalConstants;

  // upload video variables
  fileTypeError = false;
  fileTypeErrorTemp = false
  videoLengthError = false;
  videoLengthErrorTemp = false;
  videoSizeError = false;
  videoSizeErrorTemp = false;
  videoFile: any = [];
  videoFileTemp:String="";
  videoFileObj:Object={}; 
  videoUrl: any;
  videoUrlTemp:any;
  isVideo = false;
  isVideoTemp = false;
  // name realted variables 
  nameInput = '';
  charlimitForName = 50;
  isNameError = false;
  selectedTabIndex = 0;
  currentTabValue = 1;
  tempObject ={};
  tempIndex = null;
  maxTabs = 5;
  maxId=1;

  // edit mode variables 
  @Input() inEditMode: any;
  isVideoTriggered = false;
  isVideoTriggeredTemp = false;
  // publish and expire variables
  isPublishDateCustomDatepicker: boolean;
  customPublishDateResult: string;
  isCustomPublishDateCorrect: boolean;
  isCustomExpiryDateCorrect: boolean;
  editPublishDateInfo: string;
  customExpiryDateResult: string;
  editExpiryDateInfo: string;
  isExpiryDatePicker: boolean;
  isExpiredDateIncorrect: boolean;
  isPublishedDateInCorrect: boolean;
  publishedTimeStamp: any;
  isCustomPublishTimeZoneSelected = false;
  isCustomExpiryTimeZoneSelected = false;
  checkedLocationUnknown: boolean;
  isSaved: boolean = false;
  onSaveClickPopup: boolean = false;
  countrylength: number = 0;
  isdisableSelectedCountry: boolean = false;
  clearLocation: boolean = false;
  cancelLocation: boolean = false;
  tabs:any = [];
  videoTabsArray:any[5]=[];
  videoUrls : any = [];
  attractorLoopData: any[] = [];
  attractorLoops: any[];
  sqId = 1;
  checkedCountry  = [];
  editCheckedCountry = [];
  countryCount=0;
  selectAllCountries=0;
  maxAllCountries=0;
  selectAllCheckbox=true;
  removeAttractLoopId: any = [];
  checkboxdisabled: boolean = false;
  initialData: any = [];
  
  constructor(
    private modalService: NgbModal,
    private oemService: OemService,
    private sanitizer: DomSanitizer) { }

    ngOnInit(): void {
      // Initialize basic values
      this.isExpiryDatePicker = false;
      this.isExpiredDateIncorrect = false;
      this.isCustomPublishDateCorrect = false;
      this.isCustomExpiryDateCorrect = false;
      this.customPublishDateResult = GlobalConstants.NOW;
      this.customExpiryDateResult = GlobalConstants.NEVER;
      this.removeAttractLoopId = [];
      this.checkboxdisabled = false;
      
      // Initialize countries
      countryConstants.forEach(element => {
        this.allcountries.push(element.CountryName);
      });
      
      if (this.inEditMode) {
        let totalLocations = 0;
        // Convert to array if single object
        this.attractorLoops = Array.isArray(this.inEditMode) ? this.inEditMode : [this.inEditMode];
        this.attractorLoops.forEach((attractLoop) => {
          const config = attractLoop.configurations ? JSON.parse(attractLoop.configurations) : attractLoop;
          
          // Process locations
          const locationArray = attractLoop.locations && JSON.parse(attractLoop.locations)?.length > 0 
            ? JSON.parse(attractLoop.locations) 
            : "";
    
          // Create data object matching your interface structure
          const loopData = {
            publishedTimeStamp: config?.publishTime || GlobalConstants.NOW,
            locations: locationArray,
            selectedLocations: [...locationArray],
            excludedCountries: this.allcountries.filter(element => !locationArray.includes(element)),
            showVideo: attractLoop.showVideo ,
            name: attractLoop.attractLoopName || '',
            id: attractLoop.attractLoopId || '',
            fileName: attractLoop.fileName || '',
            isPublishDateCustomDatepicker: !(config?.isPublishDateNow || config?.isPublishDateNow === undefined),
            editPublishDateInfo: (config?.isPublishDateNow || config?.isPublishDateNow === undefined) 
              ? GlobalConstants.NOW 
              : config?.publishTime,
            customPublishDateResult: config?.publishTime || '',
            isExpiryDatePicker: !(config?.isPublishExpiryNever || config?.isPublishExpiryNever === undefined),
            editExpiryDateInfo: (config?.isPublishExpiryNever || config?.isPublishExpiryNever === undefined)
              ? GlobalConstants.NEVER
              : config?.expireTime,
            customExpiryDateResult: config?.expireTime || '',
            groupId: config?.groupAttractLoopId,
            sequence: config?.sequence,
          };
          this.showLocationUnknown=config.showVideo;
          this.initialData.push(JSON.parse(JSON.stringify(loopData)));
          this.attractorLoopData.push(loopData);
          totalLocations += locationArray.length; //to check total count of locations in a single attract loop group
        });
        this.tabs = [...this.attractorLoopData];  
        const hasShowVideoTrue = this.attractorLoops.some(attractLoop => attractLoop.showVideo === true); 
        if(totalLocations < this.allcountries.length || !hasShowVideoTrue) {
          this.isAddMoreDisabled = false;
        }
        if(this.attractorLoops[0]?.selectedIndexNum)
          {
             this.selectTab(this.attractorLoops[0]?.selectedIndexNum);
          }
          else
          {
             this.selectTab(0);
          }
        
      } else {
        // Initialize with default values for new attractor loop
        this.attractorLoopData.push({
          publishedTimeStamp: GlobalConstants.NOW,
          locations: [],
          selectedLocations: [],
          excludedCountries: [],
          showVideo: true,
          name: '',
          id: '',
          fileName: '',
          isPublishDateCustomDatepicker: false,
          editPublishDateInfo: GlobalConstants.NOW,
          customPublishDateResult: GlobalConstants.NOW,
          isExpiryDatePicker: false,
          editExpiryDateInfo: GlobalConstants.NEVER,
          customExpiryDateResult:  GlobalConstants.NEVER
        });
        this.initialData.push(JSON.parse(JSON.stringify(this.attractorLoopData)));
        this.tabs = [...this.attractorLoopData];
        this.getCountries();  
        this.selectTab(0);      
      }

    this.maxId=this.tabs.length;
    // Get system IDs
    this.oemService.getAllSystemIds()
      .pipe(map(res => res.modelSKUs))
      .subscribe({
        next: (res) => { this.initalizeData(res); }
      });
    this.selectLable = OemConstants.SELECT;
    this.displayCountryWithFirstLetter();    
    if(!this.inEditMode){
      this.maxAllCountries=this.countryCount=this.selectAllCountries;
    }
  }
  onLocationUnknownChange (event) {
    this.showLocationUnknown = !this.showLocationUnknown;
  }
    displayCountryWithFirstLetter() {
      this.displayCountryFirstLetter = this.allcountries.reduce((acc, item) => {
        const firstLetter = item[0].toUpperCase();
        if (!acc[firstLetter]) {
          acc[firstLetter] = [];
        }
         acc[firstLetter].push({item, checked: true, tabLocations: -1});
        return acc;
      }, {});

      if(this.inEditMode){
        for(let i=-1;i<this.tabs.length;i++){
            for (const letter in this.displayCountryFirstLetter) {
              this.displayCountryFirstLetter[letter].filter(
                (country) => {
                  if(i<0){
                    this.maxAllCountries+=1;
                    country.checked=false;
                    country.tabLocations=i;
                  } else{
                    const arr=this.tabs[i].selectedLocations
                    if(arr.includes(country.item)){
                      country.checked=true;
                      country.tabLocations = i;
                    }
                  }
              });
            }
          }
        }
        this.countryCount=0;
        this.selectAllCountries=0;
        for (const letter in this.displayCountryFirstLetter) {
          this.displayCountryFirstLetter[letter].filter(
            (country) => {
              if((country.tabLocations == -1) || (country.tabLocations == this.selectedTabIndex)) {
                this.selectAllCountries+=1;
                this.countryCount+= country.checked? 1:0;
              }        
          });
        }          
      
      return this.displayCountryFirstLetter;
  }  

  // popup related 
  initalizeData(res) {
    //new added
    this.comments = this.inEditMode.comments;
    res.forEach(data => {
      this.systemIdList.set(data.systemID, [false, data.autoID]);
      this.onlyAvailableId.set(data.systemID, data.autoID);
    });
    this.selectedSystemIdList.forEach((value, key) => {
      this.systemIdList.set(key, [true, value]);
      this.alreadySelected.set(key, [true, value]);
    });
    this.alreadySelected.forEach((v, k) => {
      this.onlyAvailableId.delete(k);
    })
    // in edit mode initial data filling 
    if (this.attractorLoops) {
      Object.keys(this.attractorLoops[0].systemIDMap).forEach((data) => {
        this.systemIdList.set(this.attractorLoops[0].systemIDMap[data], [false, data]);
        this.onlyAvailableId.set(this.attractorLoops[0].systemIDMap[data], [false, data]);
        this.selectedIds.set(this.attractorLoops[0].systemIDMap[data], [true, data]);
        this.alreadySelected.delete(this.attractorLoops[0].systemIDMap[data]);
      });
      this.onSaveSystemIds();
      if(this.attractorLoops[0]?.selectedIndexNum)
      {
        this.checkNameInput(this.attractorLoops[this.attractorLoops[0].selectedIndexNum].attractLoopName, this.attractorLoops[0]?.selectedIndexNum);
      }
      else{
        this.checkNameInput(this.attractorLoops[0].attractLoopName, 0);
      }
      // Loop through all attractor loops to handle names and video URLs
      this.attractorLoops.forEach((attractLoop, index) => {
        const assetBaseURL = this.oemService.getAssetBaseURL(false);
        this.videoUrl = environment.apiBaseUrl + this.globalConst.SLASH +
          `${assetBaseURL}${OemConstants.SLASH_ATTRACTORLOOP}${OemConstants.SLASH_ATTRACTORLOOPS}${OemConstants.SLASH}${attractLoop.attractLoopId}`;

        // Store video URLs in an array or map if you need to maintain multiple URLs
        this.videoUrls.push(this.videoUrl);
      });
      this.isVideo = true;
      this.isAllValidDataSelected = this.selectedIds.size >= this.onlyAvailableId.size;
    }
    this.displayData = Array.from(this.systemIdList);
    this.showFrom = ((this.page - 1) * this.tableSize) + 1;
    this.showTo = Math.min(this.page * this.tableSize, this.displayData.length);
    if (!this.onlyAvailableId.size) {
      this.openPopup(this.systIDError, this.selectedTabIndex)
    }

  }
  clearSearch() {
    this.searchDataList1 = '';
    this.searchDataList2 = '';
    this.searchData = '';
    this.resetData();
    this.validData(this.isAllValidDataSelected);
  }
  searchIds(data) {
    if (data) {
      let filterData = []
      filterData = Array.from(this.systemIdList).filter(x => x[0].toLowerCase().includes(data.toLowerCase()));
      this.displayData = [...filterData];
      this.validData(this.isAllValidDataSelected);
      this.showFrom = ((this.page - 1) * this.tableSize) + 1;
      this.showTo = Math.min(this.page * this.tableSize, this.displayData.length);
    } else {
      this.resetData();
    }
    this.checkIDPreSelected();

  }
  resetData() {
    this.displayData = Array.from(this.systemIdList);
    this.showFrom = ((this.page - 1) * this.tableSize) + 1;
    this.showTo = Math.min(this.page * this.tableSize, this.displayData.length);
    this.selectAllDisable = false;
  }

  checkIDPreSelected() {
    let temp = [];
    this.displayData.forEach(data => {
      if (this.alreadySelected.has(data[0]))
        temp.push(true);
      else
        temp.push(false);
    });
    this.selectAllDisable = !temp.includes(false);
  }

  selectSystemId(data) {
    if (this.selectedIds.has(data[0])) {
      this.selectedIds.delete(data[0]);
    } else {
      this.selectedIds.set(data[0], data[1]);
    }
    this.validData(this.isAllValidDataSelected);
  }
  validData(value, clear?) {
    let temp = [];
    this.displayData.forEach(data => {
      if (this.onlyAvailableId.has(data[0])) {
        if (typeof value === 'object') {
          if (!clear) {
            value.set(data[0], data[1]);
          } else {
            value.delete(data[0]);
          }
        } else {
          if (!this.selectedIds.has(data[0])) {
            temp.push(false);
          } else {
            temp.push(true);
          }
        }
      }
    });
    if (typeof value === 'boolean')
      this.isAllValidDataSelected = !temp.includes(false);
  }
  selectAll(data) {
    if (data) {
      this.validData(this.selectedIds);
      this.isAllValidDataSelected = true;
    } else {
      this.validData(this.selectedIds, true);
      this.isAllValidDataSelected = false;
    }
  }
  selectAllLocation(event){
    this.clearLocation = false;
      this.countryCount=0;
      for (const letter in this.displayCountryFirstLetter) {
        this.displayCountryFirstLetter[letter] = this.displayCountryFirstLetter[letter].map(
        (country) => {
          if((country.tabLocations == -1) || (country.tabLocations == this.selectedTabIndex)) {
            country.checked = (event.target.checked)? true : false;
            this.countryCount+= country.checked? 1:0;
          }
          return country;
        });
      }
  }
  onClearLocationSelection() {
    this.clearLocation = true;
    this.countryCount=0;    
    for (const letter in this.displayCountryFirstLetter) {
      this.displayCountryFirstLetter[letter] = this.displayCountryFirstLetter[letter].map(
      (country) => {
        if((country.tabLocations == this.selectedTabIndex) || country.tabLocations == -1) {
        country.checked = false;
        }
        return country;
      });
    }
  }
  openPopup(modal, selectedTabIndex) {
    this.selectedTabIndex = selectedTabIndex;
    this.modalService.open(modal);
  }
  onTableDataChange(event) {
    this.page = event;
    this.showFrom = ((this.page - 1) * this.tableSize) + 1;
    if (this.displayData.length) {
      this.showTo = Math.min(this.page * this.tableSize, this.displayData.length);
    } else {

      this.showTo = Math.min(this.page * this.tableSize, this.systemIdList.size);
    }
  }
  onPopupCancel() {
    this.selectedIds.clear();

    if (this.mainAfterPopupDisplay.length) {
      this.mainAfterPopupDisplay.forEach(data => {
        this.selectedIds.set(data[0], data[1]);
      });
    }
    this.validData(this.isAllValidDataSelected);
  }
  onSaveSystemIds() {
    this.mainAfterPopupDisplay = Array.from(this.selectedIds);
  }
  // popup end 
  onCancle() {
    this.isCreateAttrEnable.emit(false);
    this.isVideoTriggered = false;    
    }
  // name related 
  checkNameInput(data: string, index: number) {
   
    this.isFieldRequired=false;
    this.isNameError = false;
    if (this.nameInputElement.nativeElement.value.length <= this.charlimitForName) {
      this.nameInputElement.nativeElement.value = data.trimStart();
      this.nameInput = this.nameInputElement.nativeElement.value;
      if (this.nameInputElement.nativeElement.value.length == 0) {
        this.isFieldRequired = true;
        this.isAddMoreDisabled = this.isFieldRequired;
      } else if (this.checkAddMoreButtonEnabled(index)) {
        this.isAddMoreDisabled = false;
      }
      if (this.tabs[index]) {
        this.tabs[index].name = this.nameInput;
      }
    } else {
      this.nameInput = this.nameInputElement.nativeElement.value;
      this.nameInputElement.nativeElement.value = this.nameInput.slice(0, this.charlimitForName);
    }
    
    this.setTitle();    
  }
  checkAddMoreButtonEnabled(index: number): boolean {
    if (!this.nameInputElement?.nativeElement?.value?.length || !this.tabs[index]?.fileName?.length) {
        return false;
    }
    const currentTab = this.tabs[index];
    const selectedLocationsCount = currentTab.selectedLocations.length;
    if (index === 0 && selectedLocationsCount === 0 && !this.onSaveClickPopup) {
      return false;
    } else if ((((selectedLocationsCount + this.countryCount === this.selectAllCountries) ||
      (this.selectAllCountries === this.countryCount)) && !this.showLocationUnknown && !this.checkboxdisabled && this.onSaveClickPopup) || (this.onSaveClickPopup && selectedLocationsCount === 0 && this.showLocationUnknown && !this.isSelectAllCheckboxDisabled())) {
      return true;
    }
    return selectedLocationsCount > 0 && 
           (selectedLocationsCount + this.countryCount !== this.selectAllCountries) && 
           (this.selectAllCountries !== this.countryCount);
}

  // Add this method to your component
private isSelectAllCheckboxDisabled(): boolean {
  return !(this.selectAllCountries) && this.isSaved && this.selectAllCheckbox;
}
  setTitle() {
    this.tabs[this.selectedTabIndex].name = this.nameInput;    
  }
  // end name 
  onVideoUpload(data, index) {
    this.isVideoTriggered = true;
    this.videoFile[index] = data.target.files[0];    
    this.videoFileObj=Object.assign({}, data.target.files[0])   
    this.videoFileTemp = data.target.files[0].name;
    
    const reader = new FileReader();
    const fileType: string = this.videoFile[index]?.type;
    const fileSize: number = this.videoFile[index]?.size;
    this.fileTypeError = fileType !== this.globalConst.FILE_TYPE_VIDEO_MP4;
    this.videoSizeError = fileSize > this.globalConst.UPLOAD_VIDEO_MAX_SIZE_OEM;
    this.isVideo = !(this.fileTypeError || this.videoSizeError || this.isFileError);
    this.isVideoTemp= this.isVideo;
    if (!this.fileTypeError) {
      reader.readAsDataURL(this.videoFile[index]);
      reader.onload = _event => {
        let video = document.createElement('video');
        video.preload = 'metadata';
        video.src = _event.target.result.toString();
        video.onloadedmetadata = () => {
          this.videoLengthError = video.duration > this.globalConst.UPLOAD_VIDEO_MAX_TIME_OEM;
          this.isVideo = !(this.fileTypeError || this.videoSizeError || this.videoLengthError);
          if (this.isVideo) {
            this.videoUrls[index] = this.sanitizer.bypassSecurityTrustUrl(URL.createObjectURL(this.videoFile[index])); //need to checkl
            this.tabs[index].fileName = this.videoFile[index].name;
          if (this.checkAddMoreButtonEnabled(index)) {
              this.isAddMoreDisabled = false;
            } else{
              this.isAddMoreDisabled = true;
            }
          }
        }
      }
      this.isFileError =false;
    }
  }

  // changes for IIT3-33 starts
  getCountries() {   
      this.countries = this.allcountries;
  }

   //for selecting countries from list1
   selectedCountry(country: any, event) {   
    this.clearLocation = false;
    country.checked = (event.target.checked)? true : false;
    this.countryCount+= country.checked? 1:-1;
    this.countrylength = country.checked?this.countrylength + 1:this.countrylength - 1;
  }
  checkotherTabsLocationUnknown()
  {
    let todisable =this.tabs.map(x =>x.showVideo);   
    if(todisable.includes(true))
    {
    const index =todisable.indexOf(true);
    if(index !== this.selectedTabIndex) {
      this.checkboxdisabled = true;
      return todisable.includes(true);
    }
    }    
    this.checkboxdisabled = false;
    return false;
  }
  onSaveCountriesPopup(selectedTabIndex: number) {
    this.isSaved = true;
    this.onSaveClickPopup = true;
    this.cancelLocation = false;
    for (const letter in this.displayCountryFirstLetter) {
      this.displayCountryFirstLetter[letter] = this.displayCountryFirstLetter[letter].map(
      (country) => {
        if(!country.checked && country.tabLocations == this.selectedTabIndex){
          country.tabLocations = -1;
          const arr=this.tabs[selectedTabIndex].selectedLocations
          const p=arr.includes(country.item)? arr.splice(arr.indexOf(country.item),1):'';          
          const arr1=this.tabs[selectedTabIndex].locations
          const p1=arr1.includes(country.item)? arr1.splice(arr1.indexOf(country.item),1):'';          
        }        
        if(country.checked && country.tabLocations == -1){
          country.tabLocations = this.selectedTabIndex;
          if(typeof this.tabs[selectedTabIndex].locations === 'string') {
            if(!Array.isArray(this.tabs[selectedTabIndex].locations)) {
              this.tabs[selectedTabIndex].locations = Array.from(this.tabs[selectedTabIndex].locations);
              this.tabs[selectedTabIndex].locations.push(country.item);
              this.tabs[selectedTabIndex].selectedLocations.push(country.item);
            }
          } else {
            this.tabs[selectedTabIndex].locations.push(country.item);
            this.tabs[selectedTabIndex].selectedLocations.push(country.item);
          }
        }


        return country;
      }); 
    }
    if(this.tabs.some(item => item.showVideo === true) && (this.tabs.findIndex(item => item.showVideo === true) !== selectedTabIndex))
    {
    this.tabs[selectedTabIndex].showVideo =false;
    }
    else {
    this.tabs[selectedTabIndex].showVideo =this.showLocationUnknown;
    }
    if (this.checkAddMoreButtonEnabled(selectedTabIndex)) {
      this.isAddMoreDisabled = false;
    } else{
      this.isAddMoreDisabled = true;
    }
    this.selectTab(selectedTabIndex);
  }

  onCancelCountries() {
    this.countrylength = 0;
    this.searchDataList1 = '';
    this.searchDataList2 = '';
    this.selectTab(this.selectedTabIndex);
    if(!this.isSaved) this.countryCount=this.selectAllCountries;
  }
  // ---------changes for IIT3-33 ends------
  generateGroupAttrLoopId() {
    const randomNum = crypto.getRandomValues(new Uint32Array(1))[0] % 900000 + 100000;
    return `gat${randomNum}`;
  }
  generateSequenceId() {
    return this.sqId++;
  }

  onSaveClick() {
    this.checkExpiryDateTime();
    this.customValidation();
    this.displayCountryWithFirstLetter();
    const attractGroupId = this.generateGroupAttrLoopId();
    if (!this.isPublishedDateInCorrect &&
      !this.isExpiredDateIncorrect &&
      !this.isCustomExpiryDateCorrect &&
      !this.isCustomPublishDateCorrect && !this.isCustomPublishTimeZoneSelected && !this.isCustomExpiryTimeZoneSelected) {
      if(!this.isSaved){
        this.onSaveCountriesPopup(this.selectedTabIndex);
      }
       // Loop through all tabs and create payload for each
      this.tabs.forEach((tab, index) => {
      const sequenceId = this.generateSequenceId();
      let payload = {
        attractLoopName: tab.name,
        fileName: tab.fileName,
        systemIDMap: {},
        configurations: JSON.stringify({
          publishTime: (tab.customPublishDateResult !== GlobalConstants.NOW) ?
            Utils.changeSaveDateFormat(tab.customPublishDateResult) : Utils.getCurrentDate(),
          expireTime: (tab.customExpiryDateResult !== GlobalConstants.NEVER) ?
            Utils.changeSaveDateFormat(tab.customExpiryDateResult) : GlobalConstants.NEVER,
          isPublishDateNow: !tab.isPublishDateCustomDatepicker,
          isPublishExpiryNever: !tab.isExpiryDatePicker,
          groupAttractLoopId: this.tabs[0].groupId ? this.tabs[0].groupId : attractGroupId,
          sequence: sequenceId
        }),
        locations: tab.locations?.length > 0 ? 
          JSON.stringify(tab.locations) : 
          "",
        showVideo: tab.showVideo
      };
      payload.fileName = tab.fileName;
      this.selectedIds.forEach((v, k) => {
        payload.systemIDMap[v[1]] = k;
      })
        if (this.inEditMode && tab.id) {
          const isDataChanged = this.checkAttractDataChange(payload, this.initialData[index]);
          if(isDataChanged){
            this.editAttrServiceCall(payload, tab.id, index);
          } else {
            this.onCancle();
          }
        }
      else {
        this.newAttrServiceCall(payload, index);
      }
    })
    if(this.inEditMode && this.removeAttractLoopId.length > 0) {
      this.removeAttractLoopId.forEach((id) => {
        this.oemService.deleteAttractLoop(id)
          .subscribe(res => {
            this.onCancle();
          });
      })
    }
    }
  }
  checkAttractDataChange(data, oldData){
    let newLocations= [];
    if(data.locations.length > 0)
      {
        newLocations=JSON.parse(data.locations);
      }
    const addNewLocation=newLocations.filter((v)=>{
    return oldData.locations.indexOf(v) < 0
    })    
    const oldLocations = Array.isArray(oldData.locations) ? oldData.locations : [];
    const removeOldLocation=oldLocations.filter((v)=>{
    return newLocations.indexOf(v) < 0
    })     
    const config = JSON.parse(data.configurations);
    const oldPublishDate = oldData.customPublishDateResult !== GlobalConstants.NOW ? Utils.changeSaveDateFormat(oldData.customPublishDateResult) : Utils.getCurrentDate();
    const oldExpiryDate = oldData.customExpiryDateResult !== GlobalConstants.NEVER ? Utils.changeSaveDateFormat(oldData.customExpiryDateResult) : GlobalConstants.NEVER;
    const isChanged =
    data.fileName !== oldData.fileName ||
    data.attractLoopName !== oldData.name ||
    config.publishTime !==   oldPublishDate ||
    config.expireTime !== oldExpiryDate ||
    config.isPublishDateNow === oldData.isPublishDateCustomDatepicker ||
    config.isPublishExpiryNever === oldData.isExpiryDatePicker ||
    addNewLocation.length || removeOldLocation.length ||
    data.showVideo !== oldData.showVideo;
    return isChanged;
  }
  addTab() {
    if (this.tabs[this.selectedTabIndex]?.fileName.length === 0) {
      this.isFileError = true;
    }
    if (this.tabs[this.selectedTabIndex]?.name.length === 0) {
      this.isFieldRequired = true;
    }

    if (!this.isFileError) {
      this.checkboxdisabled = false
      this.isAddMoreDisabled = true;
      this.onSaveClickPopup = false;
      this.maxId = this.maxId + 1;
      this.isFieldRequired = false;
      if (this.tabs.length < 5) {
        this.currentTabValue = this.tabs.length + 1;
        const loopData = {
          publishedTimeStamp: GlobalConstants.NOW,
          locations: [],
          selectedLocations: [],
          excludedCountries: [],
          showVideo: false,
          name: '',
          fileName: '',
          isPublishDateCustomDatepicker: false,
          editPublishDateInfo: GlobalConstants.NOW,
          customPublishDateResult: GlobalConstants.NOW,
          isExpiryDatePicker: false,
          editExpiryDateInfo: GlobalConstants.NEVER,
          customExpiryDateResult: GlobalConstants.NEVER
        };
        if(this.tabs.some(item => item.showVideo === true))
          {
          this.showLocationUnknown=false;
          }
          else
          {
         this.showLocationUnknown=true;
          }
        this.tabs.push(loopData);
        this.selectTab(this.tabs.length - 1);
      }
    }
  }
  editAttrServiceCall(payload, attractLoopId, index) {
    if(attractLoopId){
    let id = attractLoopId;   
    this.oemService.patchAttractLoop(id, payload.systemIDMap, payload.fileName, payload.attractLoopName, payload.configurations, payload.locations, payload.showVideo)
      .subscribe(res => {
        if(this.videoFile[index])
        {
         this.oemService.putAttractLoop(this.videoFile, id, index)
        .subscribe(res => {
          this.onCancle();
        })
      }
        else
        {
          this.onCancle();
        }
      }
      , err => {
        this.isNameError = true;
      });      
    // if (this.isVideoTriggered) {
      // this.oemService.putAttractLoop(this.videoFile, id, index)
      //   .subscribe(res => {
      //     this.onCancle();
      //   });
   // }
  } else {
    this.newAttrServiceCall(payload, index)
  }
  }
  newAttrServiceCall(payload, index) {
    this.oemService.createAttractLoop(payload)
      .subscribe(res => {
        let id = res.attractLoop.attractLoopId;
        this.oemService.patchAttractLoop(id, payload.systemIDMap, payload.fileName, payload.attractLoopName, payload.configurations, payload.locations, payload.showVideo)
          .subscribe(res => { });
        this.oemService.putAttractLoop(this.videoFile, id, index)
          .subscribe(res => { });
        this.onCancle();
      }, err => {
        this.isNameError = true;
      })
  }
  // For IIT2-4662
  checkStatus(status) {
    return (status === GlobalConstants.CUSTOM);
  }

  getLogoContentExpiryDate(data,index) {
    this.customExpiryDateResult = this.generateDateTimeZone(data);
    this.tabs[index].customExpiryDateResult = this.customExpiryDateResult;
  }

  generateDateTimeZone(data) {
    return `${moment(data.dateVal).format(GlobalConstants.DATE_FORMAT)} ${data.hour}:${data.min} ${data.timeZone}`;
  }
  checkIfTimeset(data, check, index) {
    if (check === 'publish') {
      if (data[0] && data[1]) {
        this.isCustomPublishDateCorrect = false;
      }
    } else {
      if (data[0] && data[1]) {
        this.isCustomExpiryDateCorrect = false;
      }
    }
  }
  customValidation() {
    if (this.isPublishDateCustomDatepicker) {
      this.isCustomPublishDateCorrect = (this.customPublishDateResult === GlobalConstants.NOW);
    }
    if (this.isExpiryDatePicker) {
      this.isCustomExpiryDateCorrect = (this.customExpiryDateResult === GlobalConstants.NEVER);
    }
  }
  
  selectCustomPublishDate(datetimeOption, index) {
    this.isPublishDateCustomDatepicker = this.checkStatus(datetimeOption);
    this.tabs[index].isPublishDateCustomDatepicker = this.isPublishDateCustomDatepicker;
    if (!this.isPublishDateCustomDatepicker && this.customPublishDateResult === GlobalConstants.NOW) {
      this.customPublishDateResult = Utils.getCurrentDate();
      this.tabs[index].customPublishDateResult = this.customPublishDateResult;
    }
    if (datetimeOption === GlobalConstants.NOW) {
      this.isCustomPublishDateCorrect = false;
      this.isCustomPublishTimeZoneSelected = false;
    }
  }

  // check if published date is smaller than today's date
  checkPublishedDateTime() {
    const today = new Date();
    let isPublishedDateSmaller: boolean;
    if (this.publishedTimeStamp.toString() !== '') {
      isPublishedDateSmaller = new Date(this.publishedTimeStamp).getTime() < new Date().getTime();
    }

    this.isPublishedDateInCorrect = isPublishedDateSmaller;
  }
  // check if expiry date is smaller than published date
  checkExpiryDateTime() {
    if (this.customExpiryDateResult !== GlobalConstants.NEVER) {
      this.isExpiredDateIncorrect = Utils.customDateCheck(this.customPublishDateResult, this.customExpiryDateResult);
    }
  }
  getLogoContentPublishDate(data, index) {
    this.customPublishDateResult = this.generateDateTimeZone(data);
    this.tabs[index].customPublishDateResult = this.customPublishDateResult;
  }

  selectExpiryDateTimeZone(datetimeOption, index) {
    this.isExpiryDatePicker = this.checkStatus(datetimeOption);
    this.tabs[index].isExpiryDatePicker = this.isExpiryDatePicker;
    if (this.isExpiryDatePicker && this.editExpiryDateInfo) {
      this.customExpiryDateResult = this.editExpiryDateInfo;
      this.tabs[index].customExpiryDateResult = this.customExpiryDateResult;
    }
    if (!this.isExpiryDatePicker && this.customExpiryDateResult === GlobalConstants.NEVER) {
      this.customExpiryDateResult = GlobalConstants.NEVER;
      this.tabs[index].customExpiryDateResult = this.customExpiryDateResult;
    }
    if (datetimeOption === GlobalConstants.NEVER) {
      this.isExpiredDateIncorrect = false;
      this.isCustomExpiryDateCorrect = false;
      this.isCustomExpiryTimeZoneSelected = false;
    }
  }

   checkTimeZone(data, check,index) {
    (check === GlobalConstants.PUBLISH) ? (this.isCustomPublishTimeZoneSelected = !data) : (this.isCustomExpiryTimeZoneSelected = !data);
  }
  selectTab(index: number,selectionMode:boolean=false) {
    this.clearLocation = false;
    this.selectAllCountries=0;  
    this.countryCount=0;
    this.isFieldRequired=false;
    this.isFileError =false;
    this.selectedTabIndex = index;
    this.editCheckedCountry = [];
    if(this.inEditMode) {
      const parselocations = this.attractorLoops.map((item)=>item.parsedLocations);
      this.editCheckedCountry.push(parselocations[this.selectedTabIndex]);
    }
    let temparray = [];
    
    for (const letter in this.displayCountryFirstLetter) {
        this.displayCountryFirstLetter[letter].filter(
          (country) => {
            country.checked=false;
            if(this.inEditMode){
              if(country.tabLocations === this.selectedTabIndex){
                country.checked = true;
              }
            } else {        
              if(((country.tabLocations == -1) && (!this.isSaved)) || (country.tabLocations == this.selectedTabIndex)) {
                country.checked=true;
              }
            }
            if((country.tabLocations == -1) || (country.tabLocations == this.selectedTabIndex)) {
              this.selectAllCountries+=1;
              this.countryCount+= country.checked? 1:0;
            }        
        });
    }
    this.selectAllCheckbox=this.selectAllCountries ? false : true;
    this.showLocationUnknown =this.tabs[index]?.showVideo;
    this.currentTabValue = index + 1;
  }
  removeTab(index: number, event: Event) {  

    for(let i=-1;i<this.tabs.length;i++){
      for (const letter in this.displayCountryFirstLetter) {
        this.displayCountryFirstLetter[letter].filter(
          (country) => {
            if(i<0){
              country.checked = false;
              country.tabLocations=i;
            } else{
                if((i < (this.tabs.length-1)) && (i >= index)){
                  const arr=this.tabs[i+1].selectedLocations
                  if(arr.includes(country.item)){
                    country.checked = true;
                    country.tabLocations = i;
                  }
                } 
                else if(i < index){
                  const arr=this.tabs[i].selectedLocations
                  if(arr.includes(country.item)){
                    country.checked = true;
                    country.tabLocations = i;
                }
              }            
            }
        });
      }
    }

    if (index === this.tabs.length-1 || this.inEditMode) { //enable add more button when last index tab removed
      this.isAddMoreDisabled = false;
    }
    this.removeAttractLoopId.push(this.tabs[index].id);
    event.stopPropagation();
    this.tabs.splice(index, 1);
    if(index>0){
      this.selectTab(index-1);
    }
    else{
      this.selectTab(index);
    }
    this.maxId=this.maxId-1; 

  }
        
  
  isSaveDisable() {
    return this.tabs.some(obj => {                 
        if (obj.fileName && obj.name && !obj.selectedLocations.length && obj.showVideo) {
          return false;
        }       
        return !obj.name || !obj.fileName || !obj.selectedLocations.length;
          });
  } 
}

